import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DraggableDirective} from './directives/draggable.directive';
import {StoreModule} from '@ngrx/store';
import {reducers} from './reducers';
import {DroppableComponent} from './components/droppable/droppable.component';

@NgModule({
  imports: [
    StoreModule.forFeature('drag-and-drop', reducers),
    CommonModule
  ],
  exports: [
    DraggableDirective,
    DroppableComponent
  ],
  declarations: [
    DraggableDirective,
    DroppableComponent
  ]
})

export class DragAndDropModule {
}
